<div class="container p-0">
  <h3 class="text-center my-3 bold">2-Step Verification</h3>
  <ng-container *ngIf="this.user_data['has_2fa_enabled']">
    <div class="row">
      <p class="text-center col-12 my-1 info mb-m-0">Please contact support@payarc.com to disable 2FA.
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="!this.user_data['has_2fa_enabled']">
    <div class="row">
      <p class="text-center col-12 my-1 info mb-m-0">Time-based one-time password (TOTP) is a computer algorithm that
        generates a one-time
        password (OTP) using the current time as a source of uniqueness. In order to set up 2FA you need first to
        install an authenticator app like Google
        Authenticator, Authy, or Microsoft Authenticator on your phone. Your one-time security code will be sent
        to {{ user_email }}. The code will expire in 10 minutes.
      </p>
    </div>
    <div class="form-group row justify-content-center" *ngIf="!emailSent">
      <div class="col-sm-4 mt-2 mb-3 text-center p-0">
        <button type="submit"
                [disabled]="loadFlag2"
                class="bt_forgot form-control max-w-210"
                (click)="sendEmail()">
          Send Email<i *ngIf="loadFlag2" class="fa fa-spinner fa-pulse ml-2"></i>
        </button>
      </div>
    </div>


    <div class="form-group row pl-5 pr-5 mb-4" *ngIf="emailSent && !qr_code">
      <span class="error_sign col-2" id="security code">!</span>
      <div class="col-sm-12">
        <div class="row">
          <label class="col-md-12 pl-0 m-0">Enter security code</label>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <input type="text"
               class="form-control security_input"
               name="security_code"
               (keypress)="numericOnly($event)"
               maxlength="6"
               required
               [(ngModel)]="security_code"
               id="security_code"
               placeholder="Type code here">
      </div>
      <div class="col-sm-12 mt-2 text-center">
        <button type="submit"
                [disabled]="loadFlag"
                class="bt_forgot form-control max-w-210"
                (click)="verify()">
          Verify<i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i>
        </button>
      </div>
    </div>

    <div *ngIf="qr_code">
      <div class="row">
        <p class="text-center col-12 my-1 info mb-m-0">Scan the image below with your Application and enter the One Time
          Code.
        </p>
      </div>
      <div class="d-flex justify-content-center align-items-center" [innerHTML]="qr_code"></div>
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <input type="text"
               class="form-control security_input"
               name="totp_security_code"
               (keypress)="numericOnly($event)"
               maxlength="6"
               required
               [(ngModel)]="totp_security_code"
               id="totp_security_code"
               placeholder="Type code here">
      </div>
      <div class="col-sm-12 mt-2 text-center">
        <button type="submit"
                [disabled]="loadFlag"
                class="bt_forgot form-control max-w-210"
                (click)="complete()">
          Complete 2FA<i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i>
        </button>
      </div>
    </div>

  </ng-container>
</div>
